import Vue from 'vue';
import preview from '../api/preview';

Vue.prototype.$previewApi = preview;
//为vue对象注入表达式替换
Vue.prototype.$replace = function (express, varible) {
    return IDM.express.replace.call(this, express, varible);
};
//为vue对象注入表达式执行
Vue.prototype.$eval = function (express, varible) {
    return IDM.express.eval.call(this, express, varible);
};


// import {
//     Drawer
// } from 'idm-antv-ui';

// Vue.use(Drawer);